/**
 * Description: query接口
 * Author: xieqy
 * Date: 2019-06-27
 * Time: 16:00
 */
export const queryApiMap = {
    /**
     *新生儿重名查询
     */
    getWxName: '/querys/v1/wxname/',
    /**
     *车辆违章查询
     */
    queryViolationNoCode: '/querys/v1/queryViolationNoCode',
    /**
     *案件查询
     */

    /**
     *营业性爆破作业单位名录查询
     */
    getExplosive: '/querys/v1/getexplosive',
    /**
     *全市门楼号查询
     * 区县
     * 乡镇
     * 街巷
     * 详细地址
     */
    getCounties: '/querys/v1/getcounties',
    getTownship: '/querys/v1/gettownship/',
    getStreets: '/querys/v1/getstreets/',
    getAddress: '/querys/v1/getaddres',
    /**
     *驾驶证记分查询
     */
    queryViolation: '/querys/v1/queryViolation',
    /**
     *EMS邮寄查询
     */
    queryEmsBycode: '/querys/v1/QueryEmsBycode',
    /**
     *出入境中介机构名录
     */
    borderListAll: '/querys/v1/borderListAll',
    borderList: '/querys/v1/borderList',
    /**
     *湖北新接口-出入境办理进度查询
     */
    queryCrjProgress: '/querys/hubeigat/crj-makecard',

    /**
     *驾照寄递异常查询
     */

    /**
     *身份证办理进度查询
     */
    queryIdCard: '/querys/v1/queryIdCard',


    queryIdCardResult: '/querys/v1/queryIdCardResult?guid=',

    /**
     *开锁业名录
     */
    lockList: '/querys/v1/lockList',
    /**
     *网上事项办理进度查询
     */

    /**
     *重名查询
     */
    queryName: '/querys/hubeigat/renameV2/',

    queryName1Szf: '/querys/hubeigat/szfTskNum/',
    /**
     * 生僻字查询
     */
    queryRare: '/querys/hubeigat/rarely/',
    /**
     *单位信誉等级评定结果
     */
    pdjgList: '/querys/v1/pdjgList',
    /**
     *公章刻制业名录（没有验证码校验）
     */
    directory: '/querys/v1/seal/directory/',
    /**
     * 湖北新写接口-公章刻制业名录（有验证码校验）
     */
    sealDirectory: '/querys/hubeigat/seal-directory',
    /**
     *印章信息查询
     */
    seal: '/querys/v1/seal/',
    /**
     * 湖北新接口
     * 返回查询证件的id
     */
    queryIdList: '/querys/hubeigat/permits',
    /**
     *获得用户违章数据
     */
    queryIllegalData: '/querys/v1/queryIllegalData/',
    /**
     * 获取机动车违法数据
     */
    queryViolationUserCenter: '/querys/v1/queryViolationUserCenter',
    /**
     * 湖北新接口-机动车违法查询
     */
    vehicleIllegal: '/querys/hubeigat/vehicle-illegal',
    /**
     * 湖北新接口-驾驶证记分查询
     */
    drivingScore: '/querys/hubeigat/driving-score',
    /**
     * 湖北新接口-身份证办证进度查询
     */
    identity: '/querys/hubeigat/identity',
    /**
     * 湖北新接口-港澳、台、异地制证查询
     */
    makecard: '/querys/hubeigat/makecard',
    /**
     * 湖北新接口-居住证办证进度查询
     */
    jzz: '/querys/hubeigat/hbjzz',
    jjsj: '/querys/hubeigat/jjsj',

    /**
     * 湖北新接口-居住证状态进度查询
     */
    jzzzt: '/querys/hubeigat/jzzzt',
    /**
     * 湖北新接口-电子证照通用查询
     */
    electronicPermit: '/querys/hubeigat/electronic-permit',
    /**
     * 武汉居住证核验接口
     */
    electronicWhPermit: '/querys/hubeigat/whjzz/wh-residence',

    elWhPermit: '/querys/hubeigat/whjzz/wh-resident',
    /**
     *湖北新接口-出入境签注查询
     */
    queryCrjApply: '/querys/hubeigat/crj-apply',

    /**
     *湖北新接口-出入境证件查询
     */
    queryCrjCard: '/querys/hubeigat/crj-card',

    /**
     * 证照二维码
     */
    qrcode: '/querys/hubeigat/qrcode',
    /**
     * 证照随机码
     */
    randomCode: '/querys/hubeigat/permit-code',
    /**
     * 湖北新接口-电子证照扫码查询（身份证。驾驶证）
     */
    electronicComm: 'querys/hubeigat/permit-info',
    /**
     * 湖北新接口-根据车牌号获取车主信息(堵路移车)
     */
    driverInfo: '/querys/hubeigat/driver-info',
    /**
     * 湖北新接口-在逃人员对比
     */
    escapeesPerson: '/querys/hubeigat/escapees-person',
    /**
     * 湖北新接口-重点人员对比
     */
    focalPerson: '/querys/hubeigat/focal-person',
    /**
     * 湖北新接口-常驻人口重名查询
     */
    residentRename: '/querys/hubeigat/rename',
    /**
     * 湖北新接口-出入境办证查询
     */
    crjPermit: '/querys/hubeigat/crj-permit',
    /**
     * 湖北新接口-户政业务办理进度查询
     */
    hzTaskStatus: '/querys/hubeigat/hz/task/status',
    /**
     * 大使馆查询
     */
    embassyQuery: '/querys/hubeigat/embassy',
    /**
     * 个人开锁业查询
     */
    personalLocker: '/querys/hubeigat/personal-locker',

    /**
     * 二维码推广查询
     */
    twoCodeQuery: '/querys/hubeigat/push/two-code',
    /**
     *  港澳台居住证受理地查询接口
     */
    gatResidence: '/querys/hubeigat/gat-residence/area',
    /**
     *  交警页面查询记分查询接口
     */
    trafficScore: '/querys/hubeigat/traffic-score',
    /**
     *  交警查询页面机动车违法/无验证码
     */
    trafficVehicleIllegal: '/querys/hubeigat/traffic-vehicle-illegal',
    /**
     * 常住人口查询
     */
    residentQuery: '/querys/hubeigat/resident-query',
    /**
     * 常住人口查询2.0
     */
    residentQuery2: '/querys/hubeigat/resident-query2',
    /**
     * 无犯罪记录证明 查询
     */
    criminalRecord: '/querys/hubeigat/criminal-record-permit-info',

    /**
     * 部门映射
     */
    deptMap: '/querys/hubeigat/dept-map',
    deptMap2: '/querys/hubeigat/dept-map2',
    /**
     * 国家卫建出生医学证明
     */
    BirthCertificate: '/querys/hubeigat/nation/birth-certificate',

    /**
     * 涉外婚姻登记信息核验服务
     */
    Registration: '/querys/hubeigat/nation/registration',

    /**
     * 新冠疫苗接种信息查询
     */
    Inoculate: '/querys/hubeigat/nation/inoculate',
    /**
     * 国家民政殡葬火化查询
     */
    Funeral: '/querys/hubeigat/nation/funeral',
    /**
     * 查询是否存在电子印章
     */
    electronicSeal: '/querys/hubeigat/electronic-seal'
}
